"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATCH_LENIENCY_LADDER = exports.MATCH_LENIENCY_RUNGS = exports.MatchLeniency = void 0;
var MatchLeniency;
(function (MatchLeniency) {
    MatchLeniency["Strict"] = "strict";
    MatchLeniency["FoldedSignalNotation"] = "folded_signal_notation";
    MatchLeniency["IgnoredConditions"] = "ignored_conditions";
    MatchLeniency["Unmatched"] = "unmatched";
})(MatchLeniency || (exports.MatchLeniency = MatchLeniency = {}));
exports.MATCH_LENIENCY_RUNGS = [
    MatchLeniency.Strict,
    MatchLeniency.FoldedSignalNotation,
    MatchLeniency.IgnoredConditions,
];
exports.MATCH_LENIENCY_LADDER = [...exports.MATCH_LENIENCY_RUNGS, MatchLeniency.Unmatched];
//# sourceMappingURL=match-leniency.js.map